@if (vm$ | async; as ctx) {
<div
  class="periods-wrapper pl-3"
  [class.justify-content-end]="!showShowMore"
  [class.pr-3]="!ctx.collapsibleInventoryOverview || !showShowMore"
>
  @if (usedTrueDemand()) {
  <atx-alert
    [severity]="severity.Information"
    class="true-demand-alert my-1 my-lg-0 h-100 align-items-center mr-auto"
  >
    <span
      i18n="
        Size grid|Size grid inventory overview true demand
        text@@inventoryOverviewTrueDemandText"
      >We can supply {{ suppliedQuantity() }} of the
      {{ quantityForSelectedSizeForPeriodForShop().quantity }} items
      requested</span
    >
  </atx-alert>
  } @if (ctx.availableBulk > 0) {
  <div class="pt-1 px-3 inventory-tile flex-1 d-flex flex-column">
    <epc-delivery-period
      data-e2e="bulk-deliveryPeriod"
      [customLabel]="bulkLabel"
      class="overview-delivery-period overview-delivery-period-bulk"
      [differentLines]="false"
      [quantity]="ctx.maxShownBulkQuantity"
      [placeholderLabel]="ctx.maxShownBulkQuantity"
      [class.delivery-active]="true"
    ></epc-delivery-period>
    <atx-progress-bar
      [max]="ctx.availableBulk"
      [value]="consumedBulk$ | async"
      [color]="bulkColor"
    ></atx-progress-bar>
  </div>
  } @for ( availableInventory of ctx.availableInventoriesWithoutBulk; track
  availableInventory.inventoryId; let first = $first; let i = $index) { @if (
  isInventoryVisible(i, maxVisibleInventories, ctx.availableBulk > 0) ) {
  <div
    class="pt-1 inventory-tile flex-1 d-flex flex-column"
    [class.pl-3]="!first"
  >
    <epc-delivery-period
      data-e2e="deliveryPeriod"
      class="overview-delivery-period"
      [differentLines]="false"
      [deliveryData]="availableInventory.deliveryPeriod"
      [quantity]="availableInventory.maxShownQuantity"
      [placeholderLabel]="availableInventory.maxShownQuantity"
      [class.delivery-active]="i === activePeriod"
      [customLabel]="
        ctx.showInventoryExternalIdAsCustomLabel
          ? inventoriesLabels[
              availableInventory.inventoryExternalId.toLowerCase()
            ]
          : undefined
      "
    ></epc-delivery-period>
    <atx-progress-bar
      [max]="min(availableInventory.maxQuantity, ctx.maxUnlimitedQuantityOrder)"
      [value]="ctx.quantitiesPerAvailableInventory[i]"
      [color]="progressBarColor(availableInventory.deliveryPeriod, i)"
    ></atx-progress-bar>
  </div>
  } } @if (ctx.showNotConsumableInventory) { @for (notConsumableInventory of
  notConsumedInventoryOverviews$ | async; track
  notConsumableInventory.inventoryId; let i = $index; let first = $first;) {
  <div
    class="pt-1 pl-3 inventory-tile flex-1 d-flex flex-column"
    [atxTooltip]="nonConsumableLabel"
  >
    <epc-delivery-period
      data-e2e="deliveryPeriod"
      class="overview-delivery-period"
      [differentLines]="false"
      [deliveryData]="notConsumableInventory.deliveryPeriod"
      [quantity]="notConsumableInventory.maxShownQuantity"
      [customLabel]="
        ctx.showInventoryExternalIdAsCustomLabel
          ? inventoriesLabels[
              notConsumableInventory.inventoryExternalId.toLowerCase()
            ]
          : undefined
      "
    ></epc-delivery-period>
    <atx-progress-bar
      [max]="notConsumableInventory.maxShownQuantity"
      [value]="0"
      color="warning"
    ></atx-progress-bar>
  </div>
  } }
</div>
@if (showShowMore) { @if (ctx.collapsibleInventoryOverview) {
<span
  class="show-more font-weight-bold mx-3 flex-shrink-0"
  (click)="showMoreToggle()"
>
  @if (!showMore) {
  <ng-container
    i18n="
      Size grid|Size grid inventory overview show more
      text@@inventoryOverviewShowMore"
  >
    Show more
  </ng-container>
  } @else {
  <ng-container
    i18n="
      Size grid|Size grid inventory overview show less
      text@@inventoryOverviewShowLess"
  >
    Show less
  </ng-container>
  }
</span>
} } } @if (isNoAvailableInventories$ | async) {
<p
  class="align-self-center px-3 m-0 text-muted"
  i18n="
    Config Strip|No available items label in inventory
    overview@@noItemsAvailable"
>
  No items available
</p>
}
